<template>
  <div class="sb-time-content">
    <div class="sb-time-content-line" />
    <div
      class="sb-time-content__dot"
      :class="[`sb-time-content__dot--${variation}`]"
    />
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </div>
</template>

<script>

export default {
  name: 'SbTimeContent',
  props: {
    /**
     * Style variation to give additional meaning.
     * `primary, error, warning, success, disabled`
     */
    variation: {
      type: String,
      default: 'primary',
      validator: (value) => {
        const matched = value.match(/(primary|error|warning|success|disabled)/);
        return matched;
      },
    },
  },
};
</script>

<style lang="scss">
@import '@src/components/Timeline/style/sb-time-content.scss';
</style>
